import axios from "axios";
import { handleSuccessOne } from "@store/action/GlobalAction";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;
const radio_id = localStorage.getItem("radio_id");

export const getBanner = (params) => (dispatch) => {
  axios
    .get(`${API}${VERSION}/banners`, { params })
    .then((response) => {
      dispatch({
        type: "GET_BANNERS",
        data: response.data.data.Banners.data,
        BannerSections: response.data.data.WebmasterBanners,
        totalPages: response.data.data.Banners.total,
        params,
      });
    });
};

export const getTypeBannerList = () => (dispatch) => {
  axios.get(`${API}${VERSION}/type_banners`).then((response) => {
    dispatch({
      type: "GET_BANNERS_TYPE",
      TypeBanners: response.data.data.TypeBanners,
    });
  });
};
export const createBanner = (data, func, params) => (dispatch) => {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("details", data.details);
  formData.append("type_banner_id", data.type);
  // formData.append("code", data.code);
  // formData.append("icon", data.icon);
  // formData.append("link_url", data.link_url);
  formData.append("radio_id", radio_id);

  {
    data.file && formData.append("file", data.file);
  }
  {
    data.file2_en && formData.append("file2_en", data.file2_en);
  }

  axios
    .post(`${API}${VERSION}/banners`, formData)
    .then((res) => {
      dispatch({
        type: "ADD_BANNER_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getBanner(params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_BANNER_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_BANNER_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};

export const editBanner = (id, data, func, params) => (dispatch) => {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("details", data.details);
  formData.append("type_banner_id", data.type);
  formData.append("status", data.status);
  // formData.append("code", data.code);
  // formData.append("icon", data.icon);
  // formData.append("link_url", data.link_url);
  formData.append("radio_id", radio_id);

  {
    data.file && formData.append("file", data.file);
  }
  // {
  //   data.file_en2 && formData.append("file_en2", data.file_en2);
  // }
  formData.append("_method", "PUT");

  axios
    .post(`${API}${VERSION}/banners/${id}`, formData)
    .then((response) => {
      dispatch({
        type: "EDIT_BANNER_SUCCESS",
        payload: response.data,
      });
      func();
      handleSuccessOne(response.data.message);
      dispatch(getBanner(params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_BANNER_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_BANNER_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};

export const deleteBanner = (id, params) => (dispatch) => {
  axios
    .delete(`${API}${VERSION}/banners/${id}`)
    .then((res) => {
      if (res.data.status === 200) {
        handleSuccessOne(res.data.message);
        dispatch(getBanner(params));
      }
    })
    .catch((err) => {
      if (err.response) {
        handleErrorOne(err.response.data.message);
      }
    });
};

export const EditStatusBanner = (id, status) => (dispatch) => {
  axios
    .put(`${API}${VERSION}/banners/update/status/${id}/?status=${status}`)
    .then((response) => {
      dispatch({
        type: "EDIT_STATUS_BANNER_SUCCESS",
        payload: response.data,
      });
      {
        status === 0
          ? handleSuccessOne("Banner status switched to Drafted ")
          : handleSuccessOne("Banner status switched to Published");
      }
      dispatch(getBanner());
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_STATUS_BANNER_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_STATUS_BANNER_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
